import React from "react";
import { Box, Typography } from "@material-ui/core";
import { getQueueHintText } from "../../services/queue/queueAccess";

const LOADING_HINT_TEXT = "Обновляем сведения о записи в электронную очередь...";

const QueueInfoHint = ({ statementStatus, currentQueue, queueLoading = false }) => {
  const stableHint = getQueueHintText(statementStatus, currentQueue);
  const hintText = stableHint || (queueLoading ? LOADING_HINT_TEXT : "");

  return (
    <Box
      borderLeft={1}
      pl={2}
      ml={1}
      borderColor="grey.400"
    >
      <Typography variant="body2" color="textSecondary">
        {hintText}
      </Typography>
    </Box>
  );
};

export default QueueInfoHint;
